import styled from 'styled-components';
import tw, { css } from 'twin.macro';
import { Caption } from '../../styled components/Typography';

export const StyledChip = styled.div(({ $variant, $bgColor, $borderColor }) => [
  tw`inline-flex items-center justify-center p-0 bg-silver-base whitespace-nowrap rounded-full`,
  'max-width: inherit;',
  $variant === 'counter' && tw`px-4 font-bold`,
  $bgColor &&
    css`
      background-color: ${$bgColor};
    `,
  $borderColor && [
    css`
      border-color: ${$borderColor};
      ${tw`border`}
    `
  ]
]);

export const StyledChipSpan = styled(Caption)(({ $variant, $textColor }) => [
  tw`px-8 py-2 truncate`,
  $variant === 'counter' && tw`py-0`,
  $textColor &&
    css`
      color: ${$textColor};
      > span,
      > p {
        color: inherit;
      }
    `
]);
